module.exports = __webpack_public_path__ + "media/assets/icons/security-f709f616034ba00c5ece2b71d56a5b28.svg";